/**
 * Errores tipados de los flujos de contraseña (recupero LION-759 + cambio LION-760).
 *
 * `AuthStore.resetPassword()` / `AuthStore.changePassword()` los lanzan para que
 * la pantalla pueda ramificar la UI sin parsear status codes: la política de
 * contraseña (400) se renderiza inline con sus violaciones; el token de reset
 * inválido/expirado (401) muestra el aviso genérico con enlace para pedir uno
 * nuevo; y la contraseña actual incorrecta (401 en el cambio) muestra su aviso.
 */

/**
 * La contraseña nueva no cumple la política del servidor (HTTP 400). El servidor
 * es la autoridad: `violations` transporta los mensajes que el backend devolvió
 * para mostrarlos tal cual, sin adivinar la política en el cliente.
 */
export class PasswordPolicyError extends Error {
  readonly violations: readonly string[];

  constructor(violations: readonly string[]) {
    super('La contraseña no cumple la política de seguridad.');
    this.name = 'PasswordPolicyError';
    this.violations = violations;
  }
}

/**
 * El token de reset falta, expiró o ya se usó (HTTP 401, `InvalidResetTokenError`
 * del backend). Nunca se revela cuál de los tres: la UI muestra un único aviso
 * genérico y ofrece pedir un enlace nuevo.
 */
export class InvalidResetTokenError extends Error {
  constructor() {
    super('El enlace no es válido o expiró.');
    this.name = 'InvalidResetTokenError';
  }
}

/**
 * Cambio de contraseña (LION-760): la contraseña ACTUAL es incorrecta, o la
 * cuenta no es local (SSO/OIDC). El backend responde 401 GENÉRICO en ambos casos
 * y nunca revela cuál: la UI muestra un único aviso ("La contraseña actual es
 * incorrecta.") sin distinguir credencial equivocada de cuenta no-local.
 */
export class IncorrectCurrentPasswordError extends Error {
  constructor() {
    super('La contraseña actual es incorrecta.');
    this.name = 'IncorrectCurrentPasswordError';
  }
}
